'use strict';

function handlePostUpdate(messageType, message) {
    if ($('.update-messages').length === 0) {
        $('body').append(
            '<div class="update-messages"></div>'
        );
    }

    $('.update-messages').append(
        '<div class="alert ' + messageType + ' data-updated text-center" role="alert">' +
        message +
        '</div>'
    );

    setTimeout(function () {
        $('.data-updated').remove();
    }, 5000);
}

$(document).ready(function () {

    if (sessionStorage.getItem('contactUsConfirmationMessage')) {
        handlePostUpdate('alert-dark', 'Thank you for contacting us.');
        sessionStorage.removeItem('contactUsConfirmationMessage');
    }

    $('body').on('submit', 'form.contactUsForm', function () {
        sessionStorage.setItem('contactUsConfirmationMessage', true);
    });
});
